import { useEffect, useState } from "react";
import { verifyGiftStoryLink } from "../../helper/api";
import queryString from "query-string";

export function useVerifyGiftStoryToken(story) {
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    async function verifyGiftStory() {
      const params = queryString.parse(window.location.search);
      if (params.token) {
        const token = params.token;
        const res = await verifyGiftStoryLink({
          storyId: story.id,
          token
        });
        if (res.success) {
          setIsValid(true);
        }
      }
    }
    verifyGiftStory();
  }, []);

  return isValid;
}
